module.exports = __webpack_public_path__ + "static/media/parallax3.534c13c5.jpg";